export const VALLADOLID_SAN_LORENZO_TOUR_KEY = "valladolid-san-lorenzo-rujan";
export const VALLADOLID_SAN_LORENZO_COVER = "/images/valladolid.jpeg";

export const VALLADOLID_SAN_LORENZO_HR_DETAILED_INFO = `VALLADOLID – Fiesta San Lorenzo, čarolija Ribera del Duero, romantična Segovia i raskoš Madrida

🗓 10. – 14. rujna 2026. | 5 dana / 4 noći
✈️ Zrakoplovom iz Zagreba (Iberia)

Doživite autentičnu Španjolsku kroz spoj tradicionalnih festivala, vrhunskih vina, srednjovjekovne arhitekture i kozmopolitskog Madrida. U vrijeme održavanja poznate Fieste de San Lorenzo, Valladolid postaje pozornica prepuna glazbe, gastronomije i španjolskog temperamenta, dok će vas Ribera del Duero osvojiti svojim vinogradima, Segovia bajkovitim ulicama i slavnim rimskim akvaduktom, a Madrid svojom elegancijom i živahnom atmosferom. Jeste li za jedan city break sa španjolskom fiestom?

📍 PROGRAM PUTOVANJA

1. DAN – 10.09.2026. | ZAGREB – MADRID – VALLADOLID
Sastanak putnika u Zračnoj luci Zagreb i prijava na let za Madrid aviokompanijom Iberia. Po dolasku u glavni grad Španjolske slijedi transfer prema Valladolidu, povijesnoj prijestolnici Castilla i León.
Po dolasku smještaj u hotel te odlazak u razgled grada:
• Plaza Mayor
• Katedrala Nuestra Señora de la Asunción
• Crkva San Pablo
• Sveučilišna četvrt
• Povijesna jezgra grada
Nakon razgleda slobodno vrijeme za uživanje u bogatom programu Fieste de San Lorenzo, najveće gradske manifestacije koja svake godine okuplja tisuće posjetitelja uz koncerte, folklorne nastupe, gastronomske sajmove i večernju zabavu.
🛏 Noćenje u Valladolidu.

2. DAN – 11.09.2026. | VALLADOLID – RIBERA DEL DUERO (FAKULTATIVNO) – VALLADOLID
Doručak.
Predlažemo fakultativni izlet u jednu od najpoznatijih španjolskih vinskih regija – Ribera del Duero.
Vožnja kroz slikovite krajolike Castille među vinogradima iz kojih dolaze neka od najcjenjenijih španjolskih vina. Tijekom izleta predviđen je posjet vinskom podrumu uz upoznavanje procesa proizvodnje vina i degustaciju.
Posjet šarmantnim vinskim selima regije te slobodno vrijeme za ručak i uživanje u lokalnim specijalitetima.
Povratak u Valladolid u večernjim satima.
Nastavak uživanja u programu Fieste de San Lorenzo.
🛏 Noćenje u Valladolidu.

Napomena: Fakultativni izlet u Ribera del Duero nije uključen u cijenu aranžmana. Tko ne želi vinsku rutu, predlažemo razgled Valladolida, šetnju parkom El Campo Grande, razgled La casa de Zorrilla i ostale znamenitosti, ručak u jednom od restorana koji nude specijalitet lechazo (malo janje hranjeno majčinim mlijekom) uz čašu dobrog vina s područja Ribera del Duero.

3. DAN – 12.09.2026. | SEGOVIA – KRALJEVSKI DRAGULJ CASTILLE
Doručak.
Odlazak na cjelodnevni izlet u Segoviju, jedan od najljepših gradova središnje Španjolske i grad pod zaštitom UNESCO-a.
Razgled grada uključuje:
• Rimski akvadukt – simbol Segovije
• Plaza Mayor
• Katedralu Segovije
• Židovsku četvrt
• Alcázar de Segovia, dvorac koji je poslužio kao inspiracija za brojne bajkovite palače
Nakon razgleda zajednički ručak u tradicionalnom restoranu poznatom po specijalitetu regije – cochinillo asado (pečeni odojak-sisavac), jednom od najpoznatijih jela kastiljske kuhinje.
Slobodno vrijeme za šetnju i fotografiranje.
Povratak u Valladolid.
Posljednje noćenje u Valladolidu, te nastavak s fiestom. Širok je spektar i raspored fiesti i raznih punktova po gradu gdje se odvijaju razne manifestacije – slobodno vrijeme i sigurno će biti za svakoga nešto zanimljivo.

4. DAN – 13.09.2026. | VALLADOLID – MADRID
Doručak i odjava iz hotela.
Polazak prema Madridu. Nakon doručka idemo na kolodvor i vlakom (sat vremena vožnje) stižemo do Madrida. Smještamo se u apartmane ili sobe u centru Madrida. U Madridu provodimo cijelo poslijepodne i večer.
Po dolasku panoramski i pješački razgled španjolske prijestolnice:
• Puerta del Sol
• Plaza Mayor
• Kraljevska palača
• Plaza de España
• Gran Vía
• Park Retiro
• Cibeles
• Paseo del Prado
Nakon razgleda slobodno vrijeme za shopping, individualne sadržaje i uživanje u atmosferi jednog od najuzbudljivijih europskih gradova. Smještaj u pansionu u samom centru Madrida.
Jedan kraljevski pogled i zalazak s madridskih terasa zvuči čarobno! S jednim od rooftopova završavamo dan i avanturu, te noćimo kratko i idemo na let ranojutarnjim avionom aviokompanije Iberia Madrid – Zagreb.

5. DAN – 14.09.2026. | MADRID – ZAGREB
Rani jutarnji transfer prema zračnoj luci Madrid.
Prijava na let za Zagreb.
Dolazak u Zagreb prema redu letenja.

💰 CIJENA ARANŽMANA (bazirano na 10 putnika)
FIRST MINUTE CIJENA vrijedi do 10.07.2026.: 890,00 € po osobi
REDOVNA CIJENA: 990,00 € po osobi od 10.07.2026. do 10.08.2026.
LAST MINUTE CIJENA: 1.090,00 € po osobi od 10.08.2026.

✅ CIJENA UKLJUČUJE
Povratni zrakoplovni prijevoz Zagreb – Madrid – Zagreb • Pristojbe zračnih luka • Prijevoz prema programu Madrid – Valladolid – Madrid, Valladolid – Segovia – Valladolid • Transferi do smještaja i aerodroma • 3 noćenja s doručkom u Valladolidu • 1 noćenje s doručkom u pansionu u centru Madrida • Razgled Valladolida • Izlet i razgled Segovije • Razgled Madrida • Pratitelja putovanja na hrvatskom jeziku • Organizaciju i jamčevinu putovanja

❌ CIJENA NE UKLJUČUJE
Fakultativni izlet Ribera del Duero s degustacijom vina • Ulaznice za objekte koji se posjećuju • Osobne troškove, ručkove, večere • Putno osiguranje (preporučujemo Grawe)

🌟 POSEBAN DOŽIVLJAJ PUTOVANJA
🎉 Fiesta San Lorenzo u Valladolidu • 🍷 Vinska regija Ribera del Duero • 🏰 UNESCO grad Segovia • 🍽 Tradicionalni ručak s cochinillo asado • 🏙 Smještaj u centru Madrida • Spoj kulture, gastronomije, vina i španjolskog načina života

💳 UVJETI PLAĆANJA
Za potvrdu rezervacije potrebno je uplatiti akontaciju u iznosu od 40% ukupne cijene aranžmana po osobi na broj računa HR7523400093207336956. Uplata akontacije smatra se potvrdom rezervacije i prihvaćanjem ponude. Rokovi za first, regular i last minute navedeni su uz cijene. Preostali iznos potrebno je uplatiti najkasnije 20 dana prije polaska na putovanje. U slučaju neplaćanja preostalog iznosa u navedenom roku, organizator zadržava pravo otkazivanja rezervacije.

NAPOMENA: raspored programa po danima promjenjiv je do 2 tjedna prije puta, dok ne dobijemo termine za odgovarajuće aktivnosti.

📞 Rezervacije i informacije
Email: info@linatravelina.eu | Telefon: +385 91 214 4477

TraveLina – putovanja s karakterom.`;

export const VALLADOLID_SAN_LORENZO_EN_DETAILED_INFO = `VALLADOLID – Fiesta San Lorenzo, Ribera del Duero magic, romantic Segovia and Madrid's splendour

🗓 10–14 September 2026 | 5 days / 4 nights
✈️ Flight from Zagreb (Iberia)

Experience authentic Spain through traditional festivals, outstanding wines, medieval architecture and cosmopolitan Madrid. During the famous Fiesta de San Lorenzo, Valladolid becomes a stage full of music, gastronomy and Spanish spirit; Ribera del Duero captivates with its vineyards, Segovia with fairy-tale streets and the Roman aqueduct, and Madrid with elegance and vibrant atmosphere. Ready for a city break with a Spanish fiesta?

📍 TRAVEL PROGRAMME

DAY 1 – 10 SEP 2026 | ZAGREB – MADRID – VALLADOLID
Meeting at Zagreb Airport and check-in for the Iberia flight to Madrid. On arrival, transfer to Valladolid, historic capital of Castile and León.
Hotel check-in and city tour:
• Plaza Mayor
• Cathedral of Our Lady of the Assumption
• Church of San Pablo
• University quarter
• Historic city centre
Free time to enjoy the Fiesta de San Lorenzo programme – concerts, folk performances, food fairs and evening entertainment.
🛏 Overnight in Valladolid.

DAY 2 – 11 SEP | VALLADOLID – RIBERA DEL DUERO (OPTIONAL) – VALLADOLID
Breakfast.
Optional excursion to Ribera del Duero, one of Spain's most renowned wine regions.
Drive through Castile's picturesque landscapes among vineyards producing some of Spain's finest wines. Visit to a winery with introduction to winemaking and tasting.
Charming wine villages and free time for lunch and local specialities.
Return to Valladolid in the evening; continue enjoying the fiesta.
🛏 Overnight in Valladolid.

Note: Optional Ribera del Duero excursion not included. Alternative: explore Valladolid, El Campo Grande park, Casa de Zorrilla and lechazo lunch with Ribera wine.

DAY 3 – 12 SEP | SEGOVIA – JEWEL OF CASTILE
Breakfast.
Full-day excursion to UNESCO-listed Segovia.
Tour includes:
• Roman aqueduct – symbol of Segovia
• Plaza Mayor
• Segovia Cathedral
• Jewish quarter
• Alcázar de Segovia
Group lunch with cochinillo asado (roast suckling pig), a hallmark of Castilian cuisine.
Free time for walks and photos.
Return to Valladolid. Last night in Valladolid with fiesta events across the city.

DAY 4 – 13 SEP | VALLADOLID – MADRID
Breakfast and hotel check-out.
Train to Madrid (approx. 1 hour). Accommodation in the city centre. Afternoon and evening in Madrid.
Panoramic and walking tour:
• Puerta del Sol • Plaza Mayor • Royal Palace • Plaza de España • Gran Vía • Retiro Park • Cibeles • Paseo del Prado
Free time for shopping and individual activities. Guesthouse in central Madrid.
Sunset from a Madrid rooftop – magical end to the day before the early flight home.

DAY 5 – 14 SEP | MADRID – ZAGREB
Early transfer to Madrid Airport. Flight to Zagreb per schedule.

💰 PACKAGE PRICE (based on 10 travellers)
FIRST MINUTE until 10 Jul 2026: €890.00 per person
REGULAR: €990.00 per person from 10 Jul to 10 Aug 2026
LAST MINUTE: €1,090.00 per person from 10 Aug 2026

✅ PRICE INCLUDES
Return flight Zagreb–Madrid–Zagreb • Airport taxes • Transport per programme • Transfers • 3 nights B&B Valladolid • 1 night B&B central Madrid • Valladolid tour • Segovia excursion • Madrid tour • Tour leader in Croatian • Organisation and travel guarantee

❌ NOT INCLUDED
Optional Ribera del Duero excursion • Entrance tickets • Personal expenses, lunches, dinners • Travel insurance (Grawe recommended)

🌟 HIGHLIGHTS
🎉 Fiesta San Lorenzo • 🍷 Ribera del Duero • 🏰 UNESCO Segovia • 🍽 Cochinillo asado • 🏙 Central Madrid • Culture, gastronomy, wine and Spanish lifestyle

💳 PAYMENT
40% deposit on HR7523400093207336956 confirms booking. Balance due at least 20 days before departure.

📞 info@linatravelina.eu | +385 91 214 4477 | TraveLina – trips with character!`;

export const VALLADOLID_SAN_LORENZO_DE_DETAILED_INFO = `VALLADOLID – Fiesta San Lorenzo, Ribera del Duero, romantisches Segovia und Madrids Pracht

🗓 10.–14. September 2026 | 5 Tage / 4 Nächte
✈️ Flug ab Zagreb (Iberia)

Authentisches Spanien: Festivals, Spitzenweine, mittelalterliche Architektur und kosmopolitisches Madrid. Während der Fiesta de San Lorenzo wird Valladolid zur Bühne voller Musik und Gastronomie; Ribera del Duero, Segovia (UNESCO) und Madrid runden das Erlebnis ab.

📍 PROGRAMM

TAG 1 – 10.09. | ZAGREB – MADRID – VALLADOLID
Treffen am Flughafen Zagreb, Iberia-Flug nach Madrid, Transfer nach Valladolid. Stadtrundgang: Plaza Mayor, Kathedrale, San Pablo, Universitätsviertel. Abends Fiesta de San Lorenzo.
🛏 Übernachtung Valladolid.

TAG 2 – 11.09. | RIBERA DEL DUERO (OPTIONAL) – VALLADOLID
Frühstück. Optionaler Ausflug Ribera del Duero: Weinberge, Weingutbesuch, Verkostung, charmante Dörfer. Abends Fiesta. Alternative: Valladolid, El Campo Grande, Lechazo-Mittagessen.
🛏 Übernachtung Valladolid.

TAG 3 – 12.09. | SEGOVIA
Ganztagesausflug UNESCO-Stadt: Aquädukt, Plaza Mayor, Kathedrale, jüdisches Viertel, Alcázar. Gemeinsames Mittagessen mit Cochinillo asado. Rückkehr Valladolid.
🛏 Letzte Nacht Valladolid.

TAG 4 – 13.09. | MADRID
Frühstück, Zug nach Madrid (ca. 1 Std.). Panorama- und Stadtrundgang: Puerta del Sol, Plaza Mayor, Königspalast, Gran Vía, Retiro, Cibeles, Paseo del Prado. Freizeit. Pension im Zentrum. Rooftop-Sonnenuntergang.
🛏 Übernachtung Madrid.

TAG 5 – 14.09. | MADRID – ZAGREB
Früher Transfer, Flug nach Zagreb.

💰 PAKETPREIS (10 Reisende)
First minute bis 10.07.2026: 890,00 € p. P. | Regulär 10.07.–10.08.: 990,00 € | Last minute ab 10.08.: 1.090,00 €

✅ INKLUSIVE
Flug Zagreb–Madrid–Zagreb • Gebühren • Transport • Transfers • 3 Nächte Frühstück Valladolid • 1 Nacht Frühstück Madrid • Valladolid & Segovia & Madrid • Reiseleitung (KR) • Organisation

❌ NICHT INKLUSIVE
Optional Ribera del Duero • Eintritte • Mahlzeiten • Versicherung (Grawe empfohlen)

💳 40 % Anzahlung auf HR7523400093207336956; Rest spätestens 20 Tage vor Abreise.

📞 info@linatravelina.eu | +385 91 214 4477 | TraveLina`;

export const VALLADOLID_SAN_LORENZO_ES_DETAILED_INFO = `VALLADOLID – Fiesta San Lorenzo, Ribera del Duero, Segovia romántica y esplendor de Madrid

🗓 10–14 septiembre 2026 | 5 días / 4 noches
✈️ Vuelo desde Zagreb (Iberia)

España auténtica: fiestas tradicionales, vinos excepcionales, arquitectura medieval y Madrid cosmopolita. Durante la Fiesta de San Lorenzo, Valladolid se llena de música y gastronomía; Ribera del Duero, Segovia (UNESCO) y Madrid completan la experiencia.

📍 PROGRAMA

DÍA 1 – 10 sep | ZAGREB – MADRID – VALLADOLID
Encuentro en el aeropuerto de Zagreb, vuelo Iberia a Madrid, traslado a Valladolid. Visita: Plaza Mayor, catedral, San Pablo, barrio universitario. Tarde libre en la Fiesta de San Lorenzo.
🛏 Noche en Valladolid.

DÍA 2 – 11 sep | RIBERA DEL DUERO (OPCIONAL) – VALLADOLID
Desayuno. Excursión opcional a Ribera del Duero: viñedos, bodega, cata, pueblos vinícolas. Regreso y fiesta. Alternativa: Valladolid, El Campo Grande, lechazo.
🛏 Noche en Valladolid.

DÍA 3 – 12 sep | SEGOVIA
Excursión de día completo (UNESCO): acueducto, Plaza Mayor, catedral, barrio judío, Alcázar. Almuerzo grupal con cochinillo asado. Regreso a Valladolid.
🛏 Última noche en Valladolid.

DÍA 4 – 13 sep | MADRID
Desayuno, tren a Madrid (1 h). Visita panorámica y a pie: Puerta del Sol, Plaza Mayor, Palacio Real, Gran Vía, Retiro, Cibeles, Paseo del Prado. Pensión en el centro. Atardecer en rooftop.
🛏 Noche en Madrid.

DÍA 5 – 14 sep | MADRID – ZAGREB
Traslado temprano, vuelo a Zagreb.

💰 PRECIO (10 viajeros)
First minute hasta 10 jul 2026: 890,00 € | Regular 10 jul–10 ago: 990,00 € | Last minute desde 10 ago: 1.090,00 €

✅ INCLUYE
Vuelo Zagreb–Madrid–Zagreb • Tasas • Transporte • Traslados • 3 noches desayuno Valladolid • 1 noche desayuno Madrid • Visitas Valladolid, Segovia y Madrid • Guía (HR) • Organización

❌ NO INCLUYE
Excursión opcional Ribera del Duero • Entradas • Comidas • Seguro (recomendamos Grawe)

💳 Anticipo 40 % en HR7523400093207336956; resto 20 días antes de la salida.

📞 info@linatravelina.eu | +385 91 214 4477 | TraveLina`;

const VALLADOLID_SAN_LORENZO_DETAILED_INFO = {
  hr: VALLADOLID_SAN_LORENZO_HR_DETAILED_INFO,
  en: VALLADOLID_SAN_LORENZO_EN_DETAILED_INFO,
  de: VALLADOLID_SAN_LORENZO_DE_DETAILED_INFO,
  es: VALLADOLID_SAN_LORENZO_ES_DETAILED_INFO,
};

export function mergeValladolidSanLorenzoIfMissing(tours, galleryPaths = []) {
  if (!Array.isArray(tours)) return tours;
  const key = VALLADOLID_SAN_LORENZO_TOUR_KEY;
  const existing = tours.find((t) => t?.key === key);

  if (existing) {
    return tours.map((tour) => {
      if (tour?.key !== key) return tour;
      return {
        ...tour,
        detailedInfo: { ...VALLADOLID_SAN_LORENZO_DETAILED_INFO },
        image: tour.image || VALLADOLID_SAN_LORENZO_COVER,
        gallery:
          Array.isArray(tour.gallery) && tour.gallery.length > 0
            ? tour.gallery
            : galleryPaths.length > 0
              ? galleryPaths
              : [VALLADOLID_SAN_LORENZO_COVER],
      };
    });
  }

  const template =
    tours.find((t) => t?.key === "valladolid-1tjedan") ||
    tours.find((t) => t?.key === "madrid-segovia") ||
    tours[0];
  if (!template) return tours;

  const nextId = Math.max(0, ...tours.map((t) => Number(t?.id) || 0)) + 1;
  const newTour = {
    ...template,
    id: nextId,
    key,
    category: "city",
    days: 5,
    nights: 4,
    country: "Spain",
    date: "2026-09-10",
    price: 890,
    tag: "Last Minute",
    image: VALLADOLID_SAN_LORENZO_COVER,
    blogText: { hr: "", en: "", de: "", es: "" },
    gallery: galleryPaths.length > 0 ? [...galleryPaths] : [VALLADOLID_SAN_LORENZO_COVER],
    detailedInfo: VALLADOLID_SAN_LORENZO_DETAILED_INFO,
  };
  return [...tours, newTour];
}
